module.exports = __webpack_public_path__ + "img/submenu-mob-close.d931d516.svg";